import { faHome, faMessage, faPlus, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';
import { navigateSection } from '../Component/ScreenTransition';
import useNotification from '../Hook/notification';
import { displayPopin } from '../Hook/popins';
import useUser from '../Hook/user';

function MenuMobile() {
  const navigate = useNavigate();
  const user = useUser();
  const notification = useNotification();
  const location = useLocation();
  // The badge the hamburger used to carry: one sum drives both visibility and
  // the count, so they can never disagree.
  const youBadge = notification.profile_visit + notification.epheme_like + notification.follow;

  return (
    <div className='lg:hidden'>
      {/* The feed panel behind this bar is the same surface, so a tone step alone
          leaves nothing between them. The bar casts its own shadow up onto the
          content instead, with a hairline to catch the edge. */}
      <div id="bottom-bar" data-testid="mobile-navigation" className='h-bottom-nav w-full fixed z-40 bg-panel shadow-nav left-0 bottom-0 flex [&>*]:flex-1 gap-x-[1px]'>
        <div data-testid="mobile-nav-home" onClick={() => {
          if(location.pathname === "/") window.scrollTo({top: 0, left: 0, behavior: "smooth"})
          else navigate("/")
        }} className={'h-full flex flex-col justify-center items-center text-muted gap-1 ' +
          (location.pathname === "/" ? ' !text-accent' : '')
        }>
          <FontAwesomeIcon className='w-1/3 h-1/3' icon={faHome} />
          <div className='text-xs'><FormattedMessage id="menu__home" /></div>
        </div>
        {/* /top is the members page's Top tab now, so the slot lights there too. */}
        <div data-testid="mobile-nav-members" onClick={() => {
          if(["/members", "/top"].includes(location.pathname)) window.scrollTo({top: 0, left: 0, behavior: "smooth"})
            else navigate("/members")
        }} className={'h-full flex flex-col justify-center items-center text-muted whitespace-nowrap gap-1 ' +
          (["/members", "/top"].includes(location.pathname) ? ' !text-accent' : '')
        }>
          <FontAwesomeIcon className='w-1/3 h-1/3' icon={faUsers} />
          <div className='text-xs'><FormattedMessage id="menu_desktop__members" /></div>
        </div>
        <div data-testid="mobile-nav-uploader" onClick={() => {
          if(user?.informations?.type === "guest") return displayPopin()("login", { errorMessage: "terminated_guest_freetour" })
          navigate("/uploader")
        }} className={'h-full flex flex-col justify-start pt-2 items-center text-muted gap-1 ' +
          (location.pathname === "/uploader" ? ' !text-accent' : '')
        }>
          {/* Raised out of the bar, so posting reads as the primary action — and it
              takes the same fill as Apply, which means a tint in dark and a solid
              accent in light, where a pale tint on near-white chrome vanishes. */}
          <div className='h-post-button w-post-button -mt-post-button-lift flex justify-center items-center rounded-avatar bg-tint-apply-bg text-tint-apply-fg shadow-post'>
            <FontAwesomeIcon className='text-xl' icon={faPlus} />
          </div>
        </div>
        <div data-testid="mobile-nav-chat" onClick={() => {
          if(location.pathname === "/chat") window.scrollTo({top: 0, left: 0, behavior: "smooth"})
          else navigate("/chat")
        }} className={'h-full flex flex-col justify-center relative items-center text-muted gap-1 ' +
          (location.pathname === "/chat" ? ' !text-accent' : '')
        }>
          <FontAwesomeIcon className='w-1/3 h-1/3' icon={faMessage} />
          <div className='text-xs'><FormattedMessage id="menu__chat" /></div>
          {notification.chat_message > 0 && <div className='absolute bg-online text-white h-4 w-4 rounded-full flex items-center justify-center top-2 right-5 text-xs'>{notification.chat_message}</div>}
        </div>
        {/* The You page's tab. It takes Top's slot, the way the canvas draws the bar —
            the rank card on the hub still leads to /top. Guests get a hub of their
            own (3d), so the tab is never dead for a visitor.
            Arriving from one of the hub's own sections plays the way-back slide. */}
        <div data-testid="mobile-nav-you" onClick={() => {
          if(location.pathname === "/you") window.scrollTo({top: 0, left: 0, behavior: "smooth"})
          else navigateSection(navigate, "/you", ["/verification", "/help", "/parameters", "/blocked", "/me"].includes(location.pathname) ? "bak" : null)
        }} className={'h-full flex flex-col justify-center relative items-center text-muted gap-1 ' +
          (location.pathname === "/you" ? ' !text-accent' : '')
        }>
          <FontAwesomeIcon className='w-1/3 h-1/3' icon={faUser} />
          <div className='text-xs'><FormattedMessage id="you__title" /></div>
          {youBadge > 0 &&
            <div className='absolute bg-online text-white min-w-[16px] h-4 px-1 rounded-full flex items-center justify-center top-1.5 right-4 text-[10px] font-semibold'>
              {youBadge > 9 ? "9+" : youBadge}
            </div>}
        </div>
      </div>
    </div>
  )
}

export default MenuMobile
